import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { MdErrorOutline, MdEventBusy, MdLinkOff } from 'react-icons/md';
import * as S from './styles';

export const InviteErrorTypes = Object.freeze({
  EXPIRED: 'expired',
  NOT_FOUND: 'notFound',
  INVALID: 'invalid',
});

const ErrorIcon = ({ type }) => {
  const icons = {
    [InviteErrorTypes.EXPIRED]: MdEventBusy,
    [InviteErrorTypes.NOT_FOUND]: MdLinkOff,
    [InviteErrorTypes.INVALID]: MdErrorOutline,
  };

  const Icon = icons[type] || MdErrorOutline;
  return <Icon size={64} />;
};

ErrorIcon.propTypes = {
  type: PropTypes.oneOf(Object.values(InviteErrorTypes)).isRequired,
};

const InviteError = ({ type = InviteErrorTypes.NOT_FOUND }) => {
  const [t] = useTranslation('personalized-invite');

  return (
    <S.Container>
      <S.ErrorCard>
        <S.IconWrapper>
          <ErrorIcon type={type} />
        </S.IconWrapper>
        <S.Title>{t(`invite-error.${type}.title`)}</S.Title>
        <S.Description>{t(`invite-error.${type}.description`)}</S.Description>
      </S.ErrorCard>
    </S.Container>
  );
};

InviteError.propTypes = {
  type: PropTypes.oneOf(Object.values(InviteErrorTypes)),
};

InviteError.defaultProps = {
  type: InviteErrorTypes.NOT_FOUND,
};

export default InviteError;
